import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/iview.js'
import './public/public.css'
import { setStore, getStore, removeStore } from '@/plugins/storage'

Vue.config.productionTip = false
Vue.prototype.setStore = setStore
Vue.prototype.getStore = getStore
Vue.prototype.removeStore = removeStore

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
